var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.reply.field.title))]),_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('img',{staticStyle:{"max-width":"640px"},attrs:{"width":"100%","src":_vm.reply.field_signature.url}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }